import APIUtils from '@spothero/utils/api';

const AffiliateAPI = {
    get(affiliateId) {
        return APIUtils.get(`affiliates/${affiliateId}/`);
    }
};

export default AffiliateAPI;



// WEBPACK FOOTER //
// ./widget/src/js/api/affiliate.js